<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/material/bom/page" getKey="rows"
			:columns="columns">
			<!-- 左侧按钮插槽 -->
			<template #buttonsL="scope">
				<el-button size="mini" icon="yicon yicon-file_download" @click="yt.showEditDialog('xinzeng',null,'w1')" plain>
					{{$t('xiazaimuban')}}
				</el-button>
				<el-button size="mini" icon="yicon yicon-files_upload" @click="yt.showEditDialog('xinzeng',null,'w1')" plain>
					{{$t('piliangshangchuang')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text"  :loading="yt.editObj.loading" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/material/property/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
			<!-- 新增/编辑弹框 -->
			<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
				:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
				<!-- 查看 -->
				<template v-if="yt.editObj.action == 'tianjiawuliao'">
					<div class="dialog-scroller">
						<add_material></add_material>
					</div>
				</template>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/basic/material/update')" type="primary">
						{{$t('tianjia')}}
					</el-button>
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
				</span>
			</el-dialog>
	</div>
</template>

<script type="text/javascript">
	import add_material from '@@/pages/web/base/matter/add_material'
	export default {
		name: 'web_base_matter_import_list',
		components: {
			add_material
		},
		data() {
			return {
				columns: [{
					label: 'wuliaobianma',
					prop: 'code',
					width: 130
				}, {
					label: 'wuliaomingcheng',
					prop: 'name',
					width: 130
				}, {
					label: 'jibenfenlei',
					prop: 'type',
					type: 'dictionary',
					key: 'CUSTOMER_MATERIAL_TYPE'
				}, {
					label: 'guige',
					prop: 'spec'
				}, {
					label: 'dangqianliaohao',
					prop: 'no'
				}, {
					label: 'jiliangdanwei',
					prop: 'unit'
				}, {
					label: 'baozhuangfangshi',
					prop: 'pack'
				}, {
					label: 'maozhong(g)',
					prop: 'grossWeight'
				}]
			}
		},
		created() {
			setTimeout(() => {
				// this.yt.conditions = {
				// 	bomId: this.$attrs.check.id,
				// 	pageNum: 1,
				// 	pageSize: 100
				// }
				this.yt.get(1);
				// this.yt.isShowPagination = false;
			}, 300)

		},
		methods: {
			// beforeAdd(params, url) {
			// 	params.bomId = this.$attrs.check.id
			// 	return params
			// },
		}
	}
</script>

<style scoped lang="scss">

</style>
